import customHeaders, { getSpace } from '../../common/headers';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useEffect, useRef } from 'react';
import {
  DropDownSelector,
  RangeBox,
  TableBox,
} from '@lk-gtcom/ecomlab-components';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import useGeneralStore from '../../store/general';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { fetchApiFilterPivot } from '../../common/filtersFunc';
import { BtnDropRadio } from '../../components/Buttons/BtnDropRadio/BtnDropRadio';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';
import './AnalyticsByMetrics.scss';

const AnalyticsByMetrics = ({ }) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'analytics-by-metrics');
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());

  // Дата
  const [date, setDate] = useState(periodWeek())
  const [dateFrom, dateTo] = date;

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const [checkboxValues, setCheckboxValues] = useState([])

  // Фильтры
  const filterConfig = [
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'date_from', type: 'date' },
    { key: 'date_to', type: 'date' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [pivotData, setPivotData] = useState([]);

  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedPivot, setSelectedPivot] = useState([]);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [pivotPage, setPivotPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [pivotQuery, setPivotQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.date_from) {
          setDate([
            new Date(parseInt(urlParams.date_from)),
            new Date(parseInt(urlParams.date_to)),
          ]);
        }
        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      date_from: urlParams?.date_from || dateFrom,
      date_to: urlParams?.date_to || dateTo,
    })
  }, [isReady]);

  const returnValue = (val) => {
    if (val == 'Да') return 'yes'
    if (val == 'Нет') return 'no'
    if (val == 'Не использовать') return ''
  }

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setFetchedData([]);
    setHeaders([]);
    setSort({});
  };

  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!selectedApi?.length) {
      resetTable()
      return
    }

    setLoading(true);

    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `https://apps1.ecomru.ru:4450/api/v1/pivot/table/total${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`;

    let period_total_filter;

    if (selectedPivot?.length > 0) {
      period_total_filter = selectedPivot?.map((el) => el.value);
    }

    const [date_from, date_to] = date;

    const body = JSON.stringify({
      filters: filtersParam,
      period_total_filter,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      date_from: msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      bid: returnValue(checkboxValues?.['ставка']),
      quantity: returnValue(checkboxValues?.['продажи']),
      // total: "",
      expenses: returnValue(checkboxValues?.['затраты']),
      views: returnValue(checkboxValues?.['показы']),
      // drr: ""
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return
        setLoading(false)
      })
  };

  useEffect(() => {
    if (!isReady) return;
    const abortController = new AbortController()
    fetchTableData([], abortController)
    return () => abortController.abort()
  }, [date, checkboxValues, isTableRequest]);

  // Фильтры

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      setApiData: setApiData,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      filter: 'api_id',
      setTotal: setTotalApi
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter();
  }, [apiPage, apiQuery, isFilterRequest]);

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      page: categoryPage,
      apiData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      set: setCategoryData,
      searchParam: categoryQuery,
      filter: 'category',
      setTotal: setTotalCategory
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter();
  }, [categoryPage, categoryQuery, isFilterRequest]);

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: brandPage,
      searchParam: brandQuery,
      set: setBrandData,
      filter: 'brand',
      setTotal: setTotalBrand
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter();
  }, [brandPage, brandQuery, isFilterRequest]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  const pivotFilter = () => {
    fetchApiFilterPivot({
      selectedSpace: selectedSpace?.value,
      page: pivotPage,
      searchParam: pivotQuery,
      set: setPivotData,
      setBrandData: (e) => setPivotData(e),
      filter: 'period_total_filter',
    });
  };

  useEffect(() => {
    pivotFilter();
  }, [pivotPage, pivotQuery, isFilterRequest]);

  return (
    <div className="analytics-by-metrics">
      <TitlePage
        title='Аналитика по метрикам'
      />

      <div className="analytics-by-metrics__filters">
        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
          hasSavedFilters={hasSavedFilters}
          onReset={(e) => {
            setSelectedApi([]);
            setSelectedCategory([]);
            setSelectedBrand([]);
            updateURL({
              mp: null,
              api: null,
              category: null,
              brand: null,
            });
            setIsTableRequest(!isTableRequest)
            setIsFilterRequest(!isFilterRequest)
          }}
        >
          <DropDownSelector
            state={selectedApi}
            options_prop={apiData}
            setState={setSelectedApi}
            placeholder="Площадка"
            total={totalApi}
            fetchCallback={setApiPage}
            setInputChange={setApiQuery}
            multi
            onBlur={() => {
              updateURL({ api: selectedApi });
              brandFilter();
              categoryFilter()
              setIsTableRequest(!isTableRequest)
            }}
          />
          <DropDownSelector
            state={selectedCategory}
            options_prop={categoryData}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            multi
            onBlur={() => {
              updateURL({ category: selectedCategory });
              brandFilter()
              setIsTableRequest(!isTableRequest)
            }}
          />
          <DropDownSelector
            state={selectedBrand}
            options_prop={brandData}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            multi
            onBlur={() => {
              updateURL({ brand: selectedBrand });
              setIsTableRequest(!isTableRequest)
            }}
          />

          <BtnDropRadio
            checkboxValues={checkboxValues}
            setCheckboxValues={setCheckboxValues}
            list={[]}
          />
        </FilterContainer>

        <RangeBox
          date={date}
          setDate={(e) => {
            const [newDateFrom, newDateTo] = e;
            updateURL({
              date_from: newDateFrom,
              date_to: newDateTo
            });
            setDate(e)
          }}
        />
      </div>

      <TableBox
        ref={paginatorRef}
        paginator={true}
        fetchCallback={fetchTableData}
        {...tableProps}
      />
    </div>
  );
};

export { AnalyticsByMetrics };
